import service from './service';
import { UrlBuilder } from './url-builder';

const listOfCVDS = async (companyId, page, pageSize) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/cvds/${companyId}`);

  builder.add('page', page);
  builder.add('pageSize', pageSize);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const cvdCountByCompany = async (companyId, filter) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/companies/${companyId}/cvds/count`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return 0;
};

export const getPremisesListByCompany = async (companyId) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/company/${companyId}/premise-list`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const getPremisesListByManager = async (companyId, roleId) => {
  if (!companyId) return 0;

  const builder = new UrlBuilder(`/company/${companyId}/premise-list`);
  builder.add('roleId', roleId);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

const managerListOfCVDS = async (companyId, premiseId) => {
  if (!companyId) return [];
  const builder = new UrlBuilder(`/company/${companyId}/cvd-list-by-premise/${premiseId}`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { listOfCVDS, cvdCountByCompany, managerListOfCVDS };
